import { format } from 'date-fns'
import { NumericFormat } from 'react-number-format'
import { Link } from 'react-router-dom'
import { Status } from '../../../components/cards/statusTag'
import { SearchInput } from '../../../components/inputs/searchInput'
import { TextInput } from '../../../components/inputs/textInput'
import { TableComponent } from '../../../components/table'
import {
  formatCurrency,
  getCurrencySymbol,
  parseCurrencyToNumber,
} from '../../../helpers'
import { Product } from '../../../redux-toolkits/products/products.type'
export const BulkPriceProductPicker = ({
  products,
  priceDrafts,
  loading,
  search,
  currentPage,
  totalDataCount,
  pageLimit,
  onSearch,
  onPageChange,
  onPriceChange,
}: {
  products: Product[]
  priceDrafts: Record<string, string>
  loading?: boolean
  search?: string
  currentPage: number
  totalDataCount: number
  pageLimit: number
  onSearch: (search: string) => void
  onPageChange: (page: number) => void
  onPriceChange: (product: Product, price: string) => void
}) => {
  return (
    <div className="flex flex-col gap-4">
      <SearchInput
        searchFunction={onSearch}
        placeholder="Search selected creators' products"
        initialValue={search}
        className="!max-w-full"
      />

      <TableComponent
        headers={[
          'Product',
          'Current Price',
          'New Price',
          'Change',
          'Status',
          'Created',
        ]}
        rows={products.map((product) => {
          const priceDraft = priceDrafts[product._id] ?? ''
          const parsedPrice =
            priceDraft.trim() === '' ? null : parseCurrencyToNumber(priceDraft)
          const priceDifference =
            parsedPrice !== null ? parsedPrice - product.price : 0

          return {
            id: product._id,
            content: [
              <div
                key={`${product._id}-product`}
                className="flex min-w-[260px] items-center gap-3"
              >
                <img
                  height={44}
                  width={44}
                  src={product.images[0]}
                  alt="product"
                  className="h-11 w-11 rounded-md object-cover"
                />

                <div className="flex flex-col gap-1">
                  <Link
                    to={`/products/view/${product._id}`}
                    className="text-sm text-black hover:underline"
                  >
                    {product.name}
                  </Link>
                  {product.isVariant ? (
                    <p className="text-xs text-sec-black">Variant product</p>
                  ) : undefined}
                </div>
              </div>,
              formatCurrency(product.price),
              <div key={`${product._id}-new-price`} className="min-w-[180px]">
                <NumericFormat
                  suffix={undefined}
                  prefix={getCurrencySymbol('NGN')}
                  decimalScale={2}
                  thousandSeparator
                  customInput={TextInput}
                  type="text"
                  name={`price-${product._id}`}
                  placeholder="New price"
                  value={priceDraft}
                  onChange={(event) => {
                    onPriceChange(product, event.target.value)
                  }}
                  hasIcon={false}
                />
              </div>,
              <span
                key={`${product._id}-difference`}
                className={
                  priceDifference === 0
                    ? 'text-sec-black'
                    : priceDifference > 0
                      ? 'text-success'
                      : 'text-danger'
                }
              >
                {priceDifference === 0
                  ? '-'
                  : `${priceDifference > 0 ? '+' : ''}${formatCurrency(
                      priceDifference,
                    )}`}
              </span>,
              <Status
                key={`${product._id}-status`}
                type={product.isActive ? 'success' : 'fail'}
                text={product.isActive ? 'Active' : 'Inactive'}
              />,
              format(new Date(product.createdAt), 'dd/MM/yyyy h:mma'),
            ],
          }
        })}
        loading={loading}
        isEmpty={[0, undefined].includes(products.length)}
        emptyText="No products found for the selected creators"
        currentPage={currentPage}
        totalDataCount={totalDataCount}
        pageLimit={pageLimit}
        onPageChange={onPageChange}
      />
    </div>
  )
}
